import { log } from '@/log'
import { SelectOptionList } from '@/models/api/payment/parameter/type/user-select'
import { Payment } from '@/models/api/payment/payment'
import ParametersBuilder from '@/services/payment/parameters-builder'
import { ReorderPaymentState } from '@spa/components/pages/mypage/order/reorder/model/state/reorder-payment-state'
import SimplePaymentParamBuilder from '@spa/services/order/simplePaymentParamBuilder'
import { PaymentPoint } from '@spa/store/modules/orderHistory/types'
import { Either, left, right } from 'fp-ts/lib/Either'

export function makePaymentParam(
  paymentState: ReorderPaymentState,
  appliedPoints: PaymentPoint | undefined
): Either<Error, string> {
  const { selectedPayment, variableResource } = paymentState
  if (!selectedPayment.payment) {
    return left(new Error('payment not selected.'))
  }

  // サーバー側でペイロードの構築方法が設定されていない場合
  // 2025/01時点でクレジットカードのみ
  if (selectedPayment.parameterList.isEmpty) {
    return right(makePaymentParamOld(selectedPayment.payment, appliedPoints))
  }

  // サーバーで定義された決済方法オブジェクトに従ってペイロードを構築する
  const result = ParametersBuilder.create(
    selectedPayment.parameterList,
    selectedPayment.optionList || SelectOptionList.empty(),
    variableResource || {}
  ).build()
  if (result.isLeft()) {
    const message = 'Cannot build parameters for commerce_purchase.'
    log.error({
      message,
      errors: result.value,
    })

    return left(new Error(message))
  }

  return right(JSON.stringify({
    ...(result.value),
    // ポイントはすべての決済方法に関して付与可能なので最後に結合させる
    point: appliedPoints,
  }))
}

/**
 * サーバーで定義された決済方法オブジェクトに従わないルート
 * 段階的に廃止する予定
 *
 * @deprecated
 */
function makePaymentParamOld(
  payment: Payment,
  appliedPoints: PaymentPoint | undefined
): string {
  return new SimplePaymentParamBuilder({
    payment_type: payment.id,
    point: appliedPoints,
  }).build()
}
